import React, { useState } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal, formatDatetime } from "../../../../util";
import { Link } from "react-router-dom";
import ProductTag from "./productTagForm";
import DragAndDropTable from "../../../common/DragAndDropTable";

export default function ProductTagPage(props) {
  const { disabled, match } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getProductTags = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getProductTags(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      console.log(result);
      setRows(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if (pageSize) getProductTags();
  }, [getProductTags]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete File",
      text: "Are you sure to delete this Tag?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteProductTagById(id);
        toast.dark("The Tag is deleted.");
        await getProductTags();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const bulkDelete = (ids) => {
    const promises = ids.map((id) => apiHelper.hkiff.deleteProductTagById(id));
    return Promise.all(promises);
  };

  const getMaxSeqInRows = (rows) => {
    let seq = null;
    rows.forEach((e) => {
      if ((e.seq && seq === null) || (seq !== null && e.seq > seq)) {
        seq = e.seq
      }
    })
    return seq;
  }

  const saveOrdering = async () => {
    try {
      const maxSeq = getMaxSeqInRows(rows);
      const seqData = {};
      rows.forEach((e, i) => {
        seqData[e.id] = maxSeq - i;
      });

      console.log(seqData);
      const result = await apiHelper.hkiff.orderProductTags(seqData);
      if (result.data.code === 0) {
        toast.dark("Your changes is saved.");
        await getProductTags();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Tag Name (English)",
        accessor: "nameEn",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.en.name}
            </Link>
          );
        },
      },
      {
        Header: "Tag Name (Tradition Chinese)",
        accessor: "nameTc",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.tc.name}
            </Link>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        disableGlobalFilter: true,
        Cell: ({ row }) => {
          return (
            <>
              {row.original.status ? "Active" : "Inactive"}
            </>
          );
        },
      },
      {
        Header: "Last Update",
        accessor: "updateTime",
        disableGlobalFilter: true,
        Cell: ({ row }) => {
          return formatDatetime(row.original.updateTime);
        },
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
        eShop &gt; Product Tag
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <ProductTag
            description="Add New Tag"
            submitBtnTxt="Add New Tag"
            upperBtnGroupSize="50%"
            history={props.history}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={8}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getProductTags}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={bulkDelete}
            subject="Tag"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={handleDelete}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
          />
        </Grid>
      </Grid>
    </>
  );
}
